
export default class NumberFormater {

  public static euros(amount: number, digits: number = 2): string {
    return new Intl.NumberFormat(
      'es',
      { style: 'currency', currency: 'EUR', maximumFractionDigits: digits, minimumFractionDigits: digits }
    ).format(amount);
  }

  public static percent(amount: number, digits: number = 2): string {
    return new Intl.NumberFormat('es', { maximumFractionDigits: digits, style: 'percent' })
      .format(amount);
  }
}


// WEBPACK FOOTER //
// ./src/services/number-formater/NumberFormater.service.tsx